import {Component, forwardRef, Injector} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {AbstractSingleSelectEditControlComponent} from "./abstract-single-select-edit-control.component";

const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SingleSelectEditControlComponent),
    multi: true
};

/**
 * Provides a single selection on a edit form. <wbo-select-options> is used to provide the options.
 */
@Component({
    selector: "wbo-single-select-edit-control",
    templateUrl: "./single-select-edit-control.component.html",
    providers: [CUSTOM_VALUE_ACCESSOR]
})
export class SingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<any> {
    constructor(injector: Injector) {
        super(undefined, injector);
    }
}
